import React from 'react';

import { ButtonProps } from 'antd/lib/button';
import { useTranslation } from 'react-i18next';

import { StyledButton } from './styles';

type Props = ButtonProps & {
  text?: string;
  textKey?: string;
};

const PrimaryButton: React.FC<Props> = ({ text, textKey, ...rest }) => {
  const { t } = useTranslation('translation');

  return <StyledButton {...rest}>{textKey ? t(textKey) : text}</StyledButton>;
};

export default PrimaryButton;
